import adjacencyGraphs from './adjacencyGraphs.esm.js';
import passwords from './passwords.esm.js';

var index = {
  dictionary: {
    passwords
  },
  adjacencyGraphs
};

export { index as default };
//# sourceMappingURL=index.esm.js.map
